var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
    },
    [
      _c(
        "div",
        {
          staticClass: "vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4",
        },
        [
          _c("vx-card", [
            _c(
              "div",
              {
                staticClass: "full-page-bg-color",
                attrs: { slot: "no-body" },
                slot: "no-body",
              },
              [
                _c("div", { staticClass: "vx-row no-gutter" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center",
                    },
                    [
                      _c("img", {
                        staticClass: "mx-auto",
                        attrs: {
                          src: require("@/assets/images/pages/register.jpg"),
                          alt: "register",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "vx-logo flex justify-items-center items-center mb-2 pt-4",
                        },
                        [
                          _c("img", {
                            staticClass: "mx-auto",
                            staticStyle: { "max-height": "25px" },
                            attrs: {
                              src: require("@/assets/images/logo/logo.png"),
                              alt: "logo",
                            },
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "p-4 ml-8 mr-8" }, [
                        _c("div", { staticClass: "vx-card__title" }, [
                          _c(
                            "h4",
                            { staticClass: "mb-3 grid justify-items-center" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.socialRegister
                                    ? "Falta pouco!"
                                    : "Criar Conta"
                                )
                              ),
                            ]
                          ),
                        ]),
                        _vm.socialRegister && !_vm.hasSocialDraft
                          ? _c(
                              "div",
                              { staticClass: "text-center py-4" },
                              [
                                _c("p", { staticClass: "mb-3" }, [
                                  _vm._v(
                                    " Sua sessão com o Google expirou antes de você concluir o cadastro. Clique de novo no botão do Google e você volta para cá. "
                                  ),
                                ]),
                                _c("vs-button", { attrs: { to: "/login" } }, [
                                  _vm._v("Voltar para o login"),
                                ]),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "clearfix" },
                              [
                                _vm.socialRegister
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "social-identity flex items-center mb-4 p-3 rounded",
                                        staticStyle: {
                                          background: "rgba(115,103,240,0.08)",
                                        },
                                      },
                                      [
                                        _vm.socialProfile.picture
                                          ? _c("img", {
                                              staticClass: "rounded-full mr-3",
                                              staticStyle: {
                                                width: "40px",
                                                height: "40px",
                                                "object-fit": "cover",
                                              },
                                              attrs: {
                                                src: _vm.socialProfile.picture,
                                                alt: "",
                                              },
                                            })
                                          : _vm._e(),
                                        _c("div", { staticClass: "truncate" }, [
                                          _c(
                                            "strong",
                                            { staticClass: "d-block truncate" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.socialProfile.name)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-muted truncate",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.socialProfile.email)
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "pb-1 pt-2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid mt-1 justify-items-center",
                                      attrs: { id: "person_type" },
                                    },
                                    [
                                      _c(
                                        "vs-radio",
                                        {
                                          staticClass: "hidden w-0 h-0",
                                          attrs: {
                                            "vs-name": "person_type",
                                            "vs-value": "none",
                                          },
                                          model: {
                                            value: _vm.personType,
                                            callback: function ($$v) {
                                              _vm.personType = $$v
                                            },
                                            expression: "personType",
                                          },
                                        },
                                        [_vm._v("NENHUM")]
                                      ),
                                      _c(
                                        "vs-radio",
                                        {
                                          attrs: {
                                            "vs-name": "person_type",
                                            "vs-value": "student",
                                          },
                                          model: {
                                            value: _vm.personType,
                                            callback: function ($$v) {
                                              _vm.personType = $$v
                                            },
                                            expression: "personType",
                                          },
                                        },
                                        [_vm._v("Aluno")]
                                      ),
                                      _c(
                                        "vs-radio",
                                        {
                                          attrs: {
                                            "vs-name": "person_type",
                                            "vs-value": "teacher",
                                          },
                                          model: {
                                            value: _vm.personType,
                                            callback: function ($$v) {
                                              _vm.personType = $$v
                                            },
                                            expression: "personType",
                                          },
                                        },
                                        [_vm._v("Professor")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-danger text-sm col-span-2 mt-2",
                                        },
                                        [_vm._v(_vm._s(_vm.erros.personType))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.personType === "teacher"
                                    ? _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-muted d-block mt-2 text-center",
                                        },
                                        [
                                          _vm._v(
                                            " Sua conta começa como aluno. Para dar aulas na plataforma, o estabelecimento em que você trabalha precisa vincular você ao cadastro dele — avisaremos assim que isso for possível. "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                !_vm.socialRegister
                                  ? _c(
                                      "div",
                                      { staticClass: "pb-1 pt-1" },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "name" } },
                                          [_vm._v("Nome:")]
                                        ),
                                        _c("vs-input", {
                                          staticClass: "w-full",
                                          attrs: { id: "name", name: "name" },
                                          model: {
                                            value: _vm.formName,
                                            callback: function ($$v) {
                                              _vm.formName = $$v
                                            },
                                            expression: "formName",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger text-sm",
                                          },
                                          [_vm._v(_vm._s(_vm.erros.name))]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.socialRegister
                                  ? _c(
                                      "div",
                                      { staticClass: "pb-1 pt-1" },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "email" } },
                                          [_vm._v("Email:")]
                                        ),
                                        _c("vs-input", {
                                          staticClass: "w-full",
                                          attrs: {
                                            id: "email",
                                            name: "email",
                                            type: "email",
                                          },
                                          model: {
                                            value: _vm.formEmail,
                                            callback: function ($$v) {
                                              _vm.formEmail = $$v
                                            },
                                            expression: "formEmail",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger text-sm",
                                          },
                                          [_vm._v(_vm._s(_vm.erros.email))]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "pb-1 pt-1" },
                                  [
                                    _c("label", { attrs: { for: "cpf" } }, [
                                      _vm._v("CPF:"),
                                    ]),
                                    _c("vs-input", {
                                      staticClass: "w-full",
                                      attrs: { id: "cpf", name: "cpf" },
                                      model: {
                                        value: _vm.cpf,
                                        callback: function ($$v) {
                                          _vm.cpf = $$v
                                        },
                                        expression: "cpf",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "text-danger text-sm" },
                                      [_vm._v(_vm._s(_vm.erros.cpf))]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "pb-1 pt-1" },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "birthdate" } },
                                      [_vm._v("Data de nascimento:")]
                                    ),
                                    _c("vs-input", {
                                      staticClass: "w-full",
                                      attrs: {
                                        type: "date",
                                        id: "birthdate",
                                        name: "birthdate",
                                      },
                                      model: {
                                        value: _vm.birthdate,
                                        callback: function ($$v) {
                                          _vm.birthdate = $$v
                                        },
                                        expression: "birthdate",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "text-danger text-sm" },
                                      [_vm._v(_vm._s(_vm.erros.birthdate))]
                                    ),
                                    _vm.birthdate && !_vm.isOfAge
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-danger text-sm d-block",
                                          },
                                          [
                                            _vm._v(
                                              " É necessário ter pelo menos " +
                                                _vm._s(_vm.minAge) +
                                                " anos. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "small",
                                      {
                                        staticClass: "text-muted d-block mt-1",
                                      },
                                      [
                                        _vm._v(
                                          " O cadastro é para maiores de " +
                                            _vm._s(_vm.minAge) +
                                            " anos. Menores participam das atividades matriculados por um responsável legal. "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                !_vm.socialRegister
                                  ? _c(
                                      "div",
                                      { staticClass: "pb-1 pt-1" },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "password" } },
                                          [_vm._v("Senha:")]
                                        ),
                                        _c("vs-input", {
                                          ref: "password",
                                          staticClass: "w-full",
                                          attrs: {
                                            type: "password",
                                            id: "password",
                                            name: "password",
                                          },
                                          model: {
                                            value: _vm.password,
                                            callback: function ($$v) {
                                              _vm.password = $$v
                                            },
                                            expression: "password",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger text-sm",
                                          },
                                          [_vm._v(_vm._s(_vm.erros.password))]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.socialRegister
                                  ? _c(
                                      "div",
                                      { staticClass: "pb-1 pt-1" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "password_confirmation",
                                            },
                                          },
                                          [_vm._v("Confirmação Senha:")]
                                        ),
                                        _c("vs-input", {
                                          staticClass: "w-full",
                                          attrs: {
                                            type: "password",
                                            id: "password_confirmation",
                                            name: "password_confirmation",
                                          },
                                          model: {
                                            value: _vm.password_confirmation,
                                            callback: function ($$v) {
                                              _vm.password_confirmation = $$v
                                            },
                                            expression: "password_confirmation",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-danger text-sm",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.erros.password_confirmation
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-wrap justify-left my-1",
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mb-2",
                                        model: {
                                          value: _vm.isTermsConditionAccepted,
                                          callback: function ($$v) {
                                            _vm.isTermsConditionAccepted = $$v
                                          },
                                          expression:
                                            "isTermsConditionAccepted",
                                        },
                                      },
                                      [
                                        _vm._v(" Li e aceito os "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/termos",
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("Termos de Uso")]
                                        ),
                                        _vm.termsVersion
                                          ? _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "v" + _vm._s(_vm.termsVersion)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-wrap justify-left my-1",
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mb-3",
                                        model: {
                                          value: _vm.isPrivacyPolicyAccepted,
                                          callback: function ($$v) {
                                            _vm.isPrivacyPolicyAccepted = $$v
                                          },
                                          expression: "isPrivacyPolicyAccepted",
                                        },
                                      },
                                      [
                                        _vm._v(" Li e aceito a "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/privacidade",
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("Política de Privacidade")]
                                        ),
                                        _vm.privacyVersion
                                          ? _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "v" +
                                                    _vm._s(_vm.privacyVersion)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-wrap justify-center mt-4 mr-4 ml-4",
                                  },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        staticClass:
                                          "w-full sm:w-auto sm:mb-auto sm:mt-auto mt-4 mr-4 ml-4",
                                        attrs: { disabled: !_vm.validateForm },
                                        on: { click: _vm.registerUser },
                                      },
                                      [_vm._v("Registrar")]
                                    ),
                                    _c(
                                      "vs-button",
                                      {
                                        staticClass:
                                          "w-full sm:w-auto sm:mb-auto sm:mt-auto mt-1  mr-4 ml-4",
                                        attrs: { type: "border", to: "/login" },
                                      },
                                      [_vm._v("Voltar")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.socialRegister
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-center text-muted mt-3 mb-0",
                                      },
                                      [
                                        _c("small", [
                                          _vm._v(
                                            ' Sua conta vai entrar pelo Google, sem senha. Se um dia quiser uma, use "Esqueceu a senha?" na tela de login. '
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.socialRegister
                                  ? _c("recaptcha-notice")
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }